module.exports = __webpack_public_path__ + "static/media/datacom_logo.78c6054d.png";